import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import axiosInstance from "../axiosInstance.tsx";
import { FiMenu, FiUsers } from "react-icons/fi";
import { StartInviteModal, TextModal } from "./UserModal.tsx";
import { ActionButton } from "./UserModal.tsx";
import { formatSeconds } from "./InviterBox.tsx";
import { useIsMobile } from "../App.tsx";

const Container = styled.div`
  display: flex;
  max-height: 100%;
  gap: 160px;
    @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const Column = styled.div<{ flex?: number }>`
  flex: ${(p) => p.flex || 1};
  display: flex;
  max-height:69vh;
  flex-direction: column;
       @media (max-width: 768px) {
    max-height: none;
        }
  gap: 20px;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 20px;
  max-width: 100%;
  margin-bottom: 30px;
  @media (max-width: 768px) {
    gap: 0; /* убираем промежуток между кнопками */
    margin-bottom: 20px;
    border-radius: 45px;
    min-height: 48px;
  background-color: #0E0E10;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  border-radius: 6px;
  border: 1px solid #1F1F1F;
  min-height: 40px;
  background-color: #0E0E10;
  color: #fff;
  cursor: pointer;
    @media (max-width: 768px) {
    border: none;
      background-color: transparent;
    border-radius: 48px;
    &:hover {
    background-color: rgba(255, 255, 255, 0.05);

    }
    }
  font-size: 13px;
  font-family: "Onest", sans-serif;
  transition: 0.2s;
  flex: 1;

  display: flex;           // добавлено
  align-items: center;     // центрирование по вертикали
  justify-content: center; // центрирование по горизонтали
  gap: 6px;                // расстояние между иконкой и текстом



  &:hover {
    opacity: 0.9;
    transition: 0.2s;
  }

  &:active {
    opacity: 0.8;
    transition: 0.2s;
  }
`;


const Label = styled.label<{fontSize: number}>`
  font-size: 16px;
       @media (max-width: 768px) {
    font-size: ${({fontSize}) => fontSize  ? fontSize : 14}px;  }
  color: #fff;
`;

export const Input = styled.input`
  padding: 10px 12px 10px 12px;
  border-radius: 6px;
  border: 1px solid #1F1F1F;
  background-color: #0E0E10;
  color: #fff;
  font-size: 13px;
    &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::-moz-appearance {
    textfield;
  }
         @media (max-width: 768px) {
  border: none;
  border-radius: 36px;
  padding: 10px 16px 10px 16px;
  }
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;
 
  background: #1c1c1c;

  background-color: #0E0E10;
  border-radius: 6px;
  border: 1px solid #1F1F1F;
  padding: 20px;
  max-height: 130px;
  color: #fff;

       @media (max-width: 768px) {
       border-radius: 20px;
       border: none;
        max-height: none;   /* снимаем ограничение по высоте */
    height: auto;       /* чтобы растягивалось под контент */
    overflow-y: visible; /* убираем прокрутку */
  }
  
  overflow-y: auto;
`;

const Parameter = styled.div`
display: flex;
flex-direction: column;
gap: 16px;
     @media (max-width: 768px) {
    gap: 8px; }
`
const ChatInfo = styled.div`
  display: flex;
  gap: 18px;
  align-items: center;
`;

const Avatar = styled.img`
  width: auto;
  height: 90px;
    border-radius: 100%;
  object-fit: cover;
`;

const ChatDetails = styled.div`
  display: flex;
  gap: 4px;
  flex-direction: column;
`;

const ChatTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #fff;
`;

const ChatStats = styled.div`
  font-size: 13px;
  color: #7C8086;
  font-weight: 500;
  margin-top: 4px;
`;

const ConsoleBox = styled.textarea`
  background-color: #0f0f0f;
  border-radius: 14px;
  border: 1px solid #1c1c1c;
  padding: 16px;
  color: white;
  font-family: monospace;
  font-size: 13px;
  resize: none;
  height: 200px;
  overflow-y: auto;
  flex: 1;
`;


interface Inviter {
  id: number;
  name: string;
  settings: {
    max_invites_per_chat: number;
    parallel_chats_count: number;
    max_invites_per_account: number;
    max_accounts_per_chat: number;
  };
  base: string;
  chats: string;
  invited: number;
  state: string;
  seconds_wait?: number;
  chat: {
    alive: boolean;
    title: string;
    avatar: string;
    about: string;
    members: number;
  };
}

const Count = styled.span`
  color: #7c8086; // нужный цвет
  font-weight: 400; // чтобы не было жирным
`;

interface FullInviterProps {
  inviter: Inviter;
  categories: object[];
}



const ConsoleWrapper = styled.div`
  background-color: #0f0f0f;
  border-radius: 14px;
  border: 1px solid #1c1c1c;
  padding: 16px;
  font-family: monospace;
  font-size: 13px;

  flex: 1;          /* занимает всё доступное место */
  min-height: 0;    /* критично для flex, чтобы контент не растягивал */
  overflow-y: auto; /* скролл для большого контента */
  white-space: pre-wrap;
  color: white;
`;

const ConsoleLine = styled.div<{ color?: string }>`
  color: ${({ color }) => color || "white"};
`;

export const AnimatedConsole: React.FC<{ logs: string }> = ({ logs }) => {
  const [fullHistory, setFullHistory] = useState<string[]>([]);
  const [displayedLines, setDisplayedLines] = useState<string[]>([]);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const allLines = (logs || "Логов нет").split("\n");

    // Находим новые строки, которых ещё нет в полной истории
    const newLines = allLines.filter(line => !fullHistory.includes(line));

    if (newLines.length === 0) return;

    // Добавляем новые строки в полную историю
    setFullHistory(prev => [...prev, ...newLines]);

    if(displayedLines.length == 0) {
      setDisplayedLines(newLines);
      return;
    }

    // Анимированно добавляем новые строки по одной
    newLines.forEach((line, index) => {
      setTimeout(() => {
        setDisplayedLines(prev => {
          const updated = [...prev, line].slice(-200); // отображаем только последние 200
          // Автоскролл вниз
          if (wrapperRef.current) {
            wrapperRef.current.scrollTop = wrapperRef.current.scrollHeight;
          }
          return updated;
        });
      }, index * (5000 / newLines.length)); // интервал между строками
    });
  }, [logs, fullHistory]);

  return (
    <ConsoleWrapper ref={wrapperRef}>
      {displayedLines.map((line, i) => (
        <ConsoleLine
          key={i}
          color={line.includes("Заинвайтили") ? "green" : "white"}
          style={{ opacity: 1, transform: "translateY(0)" }}
        >
          {line || "\u00A0"}
        </ConsoleLine>
      ))}
    </ConsoleWrapper>
  );
};



export const FullInviter: React.FC<FullInviterProps> = ({ inviter, categories }) => {
  const [parallelChats, setParallelChats] = useState(inviter.settings.parallel_chats_count);
  const [limitPerChat, setLimitPerChat] = useState(inviter.settings.max_invites_per_chat);
  const [limitPerAccount, setLimitPerAccount] = useState(inviter.settings.max_invites_per_account);
  const [accountsPerChat, setAccountsPerChat] = useState(inviter.settings.max_accounts_per_chat);
  const [base, setBase] = useState(inviter.base);
  const [chats, setChats] = useState(inviter.chats);
  const [state, setState] = useState(inviter.state);
  const [logs, setLogs] = useState(inviter.logs);
  const [secondsLeft, setSecondsLeft] = useState(0);

    useEffect(() => {
    if (!inviter.fetchTime || !inviter.seconds_wait) return;

    // разница между now и fetchTime
    const now = new Date();
    const fetchTime = new Date(inviter.fetchTime);
    const elapsed = Math.floor((now.getTime() - fetchTime.getTime()) / 1000);

    // стартовое значение таймера
    let remaining = inviter.seconds_wait - elapsed;
    if (remaining < 0) remaining = 0;

    setSecondsLeft(remaining);

    const interval = setInterval(() => {
      setSecondsLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [inviter.fetchTime, inviter.seconds_wait]);

  useEffect(() => {
    setParallelChats(inviter.settings.parallel_chats_count);
    setLimitPerChat(inviter.settings.max_invites_per_chat);
    setLimitPerAccount(inviter.settings.max_invites_per_account);
    setAccountsPerChat(inviter.settings.max_accounts_per_chat);
    setState(inviter.state)
    setBase(inviter.base);
    setChats(inviter.chats);
    setLogs(inviter.logs);
  }, [inviter]);

    const run = async (count: number, category: string) => {
      await axiosInstance.post(`/runInvite`, {inviter_id: inviter.id, category, count})
      setState("waiting");
  }

  const isMobile = useIsMobile();

  const [showBaseModal, setShowBaseModal] = useState(false);
  const [showChatsModal, setShowChatsModal] = useState(false);
    const [showRunModal, setShowRunModal] = useState(false);

      const updateSetting = async (key: string, value: number) => {
    try {
      await  axiosInstance.put(`/settings/${inviter.id}`, { key, value });
      console.log(`Обновлено: ${key} = ${value}`);
    } catch (err) {
      console.error("Ошибка обновления", key, err);
    }
  };


  const updateTxt = async (endpoint: "chats" | "base", data: string) => {
        try {
      await  axiosInstance.put(`/${endpoint}/${inviter.id}`, { data });
      if(endpoint == "chats") { setChats(data);} else {setBase(data)};
    } catch (err) {
      console.error("Ошибка обновления" , err);
    }
  }


  return (
    <Container>
      <StartInviteModal defaultValue={Math.round(limitPerChat / 30)} onRun={run} categories={categories} isOpen={showRunModal} onClose={() => setShowRunModal(false)}></StartInviteModal>
        <TextModal onSave={(value) => {setShowBaseModal(false); updateTxt("base", value)}} size="l" title="База пользователей" text={base} showSearch={true} isOpen={showBaseModal} onClose={() => setShowBaseModal(false)}></TextModal>
        <TextModal onSave={(value) => {setShowChatsModal(false); updateTxt("chats", value)}} size="m" title="Список чатов" text={chats} showSearch={false} isOpen={showChatsModal} onClose={() => setShowChatsModal(false)}></TextModal>
      {!isMobile &&<>  <Column flex={1}>
        <ButtonRow>
          <Button onClick={() => setShowChatsModal(true)}>

    <FiMenu size={16} />

            Список чатов <Count>{chats.split("\n").length}</Count></Button>
          <Button onClick={() => setShowBaseModal(true)}>
         
    <FiUsers size={16} />

            База юзеров <Count>{base.split("\n").length}</Count></Button>
        </ButtonRow>

  <Parameter>
        <Label >Во сколько чатов инвайтит одновременно</Label>
        <Input
          type="number"
          defaultValue={parallelChats}
          onBlur={(e) => {
            const value = Number(e.target.value);
            setParallelChats(value);
            updateSetting("parallel_chats_count", value);
          }}
        />
      </Parameter>

      <Parameter>
        <Label>Лимит успешных инвайтов в чат</Label>
        <Input
          type="number"
          defaultValue={limitPerChat}
          onBlur={(e) => {
            const value = Number(e.target.value);
            setLimitPerChat(value);
            updateSetting("max_invites_per_chat", value);
          }}
        />
      </Parameter>

      <Parameter>
        <Label>Лимит успешных инвайтов с аккаунта</Label>
        <Input
          type="number"
          defaultValue={limitPerAccount}
          onBlur={(e) => {
            const value = Number(e.target.value);
            setLimitPerAccount(value);
            updateSetting("max_invites_per_account", value);
          }}
        />
      </Parameter>

      <Parameter>
        <Label>Кол-во аккаунтов на чат</Label>
        <Input
          type="number"
          defaultValue={accountsPerChat}
          onBlur={(e) => {
            const value = Number(e.target.value);
            setAccountsPerChat(value);
            updateSetting("max_accounts_per_chat", value);
          }}
        />
      </Parameter>
      <ActionButton onClick={() => {if(state != "not_running") {return;} setShowRunModal(true);}} style={{marginTop: "auto"}} variant={state == "not_running" ? "action" : "block" }active={state == "not_running"}>
        {state == "not_running" && "Запуск"}
        {state == "waiting" && `Ждём отлёжку (${formatSeconds(secondsLeft)})`}
        {state == "running" && `Запущено (${inviter.invited} / ${inviter.settings.max_invites_per_chat})`}
        </ActionButton>
      </Column>

      {/* Правый столбец */}
      <Column flex={1}>
        <Label fontSize={16}>Информация о чате</Label>
        <InfoBox>
        <ChatInfo>
          {inviter.chat && <>
                      <Avatar src={inviter.chat.avatar} alt={inviter.chat.title} />

            <ChatDetails>
            <ChatTitle>{inviter.chat.title}</ChatTitle>
            <ChatStats>
                {inviter.chat.members} участников
            </ChatStats>
            </ChatDetails>
            </>}

        </ChatInfo>
        </InfoBox>

        <Label>Консоль</Label>
            <AnimatedConsole logs={logs}></AnimatedConsole>
      </Column></>
    }
    {isMobile && <>
    <Column flex={1}>
        <ButtonRow>
          <Button onClick={() => setShowChatsModal(true)}>

    <FiMenu size={16} />

            Список чатов <Count>{chats.split("\n").length}</Count></Button>
          <Button onClick={() => setShowBaseModal(true)}>
         
    <FiUsers size={16} />

            База юзеров <Count>{base.split("\n").length}</Count></Button>
        </ButtonRow>
            <Label>Информация о чате</Label>
        <InfoBox>
        <ChatInfo>
          {inviter.chat && <>
                      <Avatar src={inviter.chat.avatar} alt={inviter.chat.title} />

            <ChatDetails>
            <ChatTitle>{inviter.chat.title}</ChatTitle>
            <ChatStats>
                {inviter.chat.members} участников
            </ChatStats>
            </ChatDetails>
            </>}

        </ChatInfo>
        </InfoBox>

  <Parameter>
        <Label>Во сколько чатов инвайтит одновременно</Label>
        <Input
          type="number"
          defaultValue={parallelChats}
          onBlur={(e) => {
            const value = Number(e.target.value);
            setParallelChats(value);
            updateSetting("parallel_chats_count", value);
          }}
        />
      </Parameter>

      <Parameter>
        <Label>Лимит успешных инвайтов в чат</Label>
        <Input
          type="number"
          defaultValue={limitPerChat}
          onBlur={(e) => {
            const value = Number(e.target.value);
            setLimitPerChat(value);
            updateSetting("max_invites_per_chat", value);
          }}
        />
      </Parameter>

      <Parameter>
        <Label>Лимит успешных инвайтов с аккаунта</Label>
        <Input
          type="number"
          defaultValue={limitPerAccount}
          onBlur={(e) => {
            const value = Number(e.target.value);
            setLimitPerAccount(value);
            updateSetting("max_invites_per_account", value);
          }}
        />
      </Parameter>

      <Parameter>
        <Label>Кол-во аккаунтов на чат</Label>
        <Input
          type="number"
          defaultValue={accountsPerChat}
          onBlur={(e) => {
            const value = Number(e.target.value);
            setAccountsPerChat(value);
            updateSetting("max_accounts_per_chat", value);
          }}
        />
      </Parameter>
      <ActionButton onClick={() => {if(state != "not_running") {return;} setShowRunModal(true);}} style={{marginTop: "auto"}} variant={state == "not_running" ? "action" : "block" }active={state == "not_running"}>
        {state == "not_running" && "Запуск"}
        {state == "waiting" && `Ждём отлёжку (${formatSeconds(secondsLeft)})`}
        {state == "running" && `Запущено (${inviter.invited} / ${inviter.settings.max_invites_per_chat})`}
        </ActionButton>
      </Column>

      {/* Правый столбец */}
      <Column flex={1}>

        <Label>Консоль</Label>
            <AnimatedConsole logs={logs}></AnimatedConsole>
      </Column></>
    
    }
    </Container>
  );
};
